"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WindowDimensionsProvider_1 = require("../WindowDimensionsProvider");
const ResponsiveLayout = ({ breakPoint = 640, renderMobile, renderDesktop }) => {
    const { width } = WindowDimensionsProvider_1.useWindowDimensions();
    return width > breakPoint ? renderDesktop() : renderMobile();
};
exports.default = ResponsiveLayout;
